module.exports = __webpack_public_path__ + "static/media/dustyroom_cartoon_swipe_high_pitched.9d86a17d.mp3";